import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import SellerCenterRoutes from './seller-center-routes';
import CpRoutes from './cp-routes';
import { ACCESS_DENIED, OMS_DASHBOARD_PATH, STORE_NOT_FOUND } from '../constants/seller-center-paths.js';
import { isCP } from '../utils/app-utils.js';
import { AccessDenied, StoreNotFound } from '../pages/seller-center/index.js';

const Routes = () => {
  return (
    <RouterRoutes>
      <Route exact path="/" element={<Navigate to={OMS_DASHBOARD_PATH} />} />
      <Route path={STORE_NOT_FOUND} element={<StoreNotFound />} />
      <Route path={ACCESS_DENIED} element={<AccessDenied />} />
      <Route path="*" element={!isCP() ? <SellerCenterRoutes /> : <CpRoutes />} />
    </RouterRoutes>
  );
};

export default Routes;
